export class Point {
    x: number;
    y: number;

    constructor(x: number, y: number) {
        this.x = x;
        this.y = y;
    }

    static equals(a: Point, b: Point) {
        if (a === b) {
            return true;
        }

        if (!a || !b) {
            return false;
        }

        return a.x === b.x && a.y === b.y;
    }
}

export class Rect {
    x: number;
    y: number;
    width: number;
    height: number;

    constructor(x: number, y: number, width: number, height: number) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
}

export interface Size {
    width: number;
    height: number;
}

export function getImageUnscaledSize(image: HTMLImageElement): Size {
    return {
        width: image.naturalWidth,
        height: image.naturalHeight,
    };
}

export function calculateSizeFit(size: Size, maxSize: Size, scaleUp: boolean = false): Size & { scaleRatio: number } {
    const imageSize = { width: size.width, height: size.height };
    let resizeRatio = Math.min(maxSize.width / imageSize.width, maxSize.height / imageSize.height);

    if (!scaleUp && resizeRatio > 1) {
        resizeRatio = 1;
    }

    return {
        width: imageSize.width * resizeRatio,
        height: imageSize.height * resizeRatio,
        scaleRatio: resizeRatio,
    };
}

